import { Box, Paper, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useMemo } from 'react';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { GoPlus } from "react-icons/go";
import { Table } from '../../../Components/Table/table.component';
import { useNavigate } from 'react-router-dom';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { useListPricePolicies } from './policies-price-list.hook';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Flex } from '../../../Components/Flex/flex.component';
import { Switch } from '../../../Components/Form/Switch/switch.component';
import { Loader } from '../../../Components/Loader';
import { Can } from '../../../Components/Can';
import { IoFilterOutline } from 'react-icons/io5';
import { FinancialFiltersDrawer } from '../../../Components/Drawer/variants/financial-filters/financial-filters-drawer.component';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { FaBox, FaEdit, FaSync, FaTrash } from 'react-icons/fa';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { DestroyProductUseCase } from '../../../Usecase/Products/destroy-product-usecase';
import { ProductsList } from '../../Products/List';
import { ListPricePoliciesUseCase } from '../../../Usecase/PricePolicies/list-price-policies-usecase';
import { DestroyPricePoliciesUseCase } from '../../../Usecase/PricePolicies/destroy-price-policies-usecase';
import { ResyncPricePoliciesUseCase } from '../../../Usecase/PricePolicies/resync-price-policies-usecase';

interface IPricePoliciesList {

    listPricePoliciesUseCase: ListPricePoliciesUseCase
    destroyPricePoliciesUseCase: DestroyPricePoliciesUseCase
    resyncPricePoliciesUseCase: ResyncPricePoliciesUseCase
}
const PricePoliciesList : FC<IPricePoliciesList> = ({ listPricePoliciesUseCase, destroyPricePoliciesUseCase, resyncPricePoliciesUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const {  totalRegisters, control, loading, handleDestroyPricePolicy, pricePolicyToDestroy, setPricePolicyToDestroy, listPolicies, data, pricePolicyToResync, setPricePolicyToResync, handleResyncPricePolicy } = useListPricePolicies({
 
        listPricePoliciesUseCase,
        
        destroyPricePoliciesUseCase,
        resyncPricePoliciesUseCase
    })


    const columns = useMemo(() => {
        const createColumns: any[] = [
         
          {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          
          {
            field: "actions",
            headerName: "Ações",
             renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Editar',
                onClick: () => navigate(`/price-policies-form/${params.row.id}`),
                
                icon: <FaEdit size={18} />
              },
              {
                title: 'Re-sincronizar Produtos',
                onClick: () => setPricePolicyToResync(params.row),
                
                icon: <FaSync size={18} />
              },
              
              
              {
                title: 'Excluir',
                onClick: () => setPricePolicyToDestroy(params.row),
                titleColor: 'error.main',
                icon: <FaTrash size={18} />
              }
            ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:products:manage']}>
        <ConfirmDialog title='Remover Política de Preços' onCancel={() => setPricePolicyToDestroy(undefined)} description='Você tem certeza?' open={!!pricePolicyToDestroy} onConfirm={handleDestroyPricePolicy}  /> 
        <ConfirmDialog title='Re-sincronizar Produtos' onCancel={() => setPricePolicyToResync(undefined)} description='Você tem certeza que deseja sincronizar o preço de todos os produtos de variações que usam essa política de preço?' open={!!pricePolicyToResync} onConfirm={handleResyncPricePolicy}  /> 
         {/* <FinancialFiltersDrawer handleSelect={e => {}} open={showFiltersModal} title='Filtros' onToggle={() => setShowFiltersModal(prev => !prev)}  />   */}
        <BaseScreen>
            <Paper >
                {loading && <Loader />}
                <BaseContentPage 
                    title='Políticas de Preços'
                    search
                    searchFunction={listPolicies}
                    breadcrumb={[{ title: 'Políticas de Preços', link: "/price-policies-list"}, { title: 'Listagem'}]}
                    Action={() => <Flex gap={2} alignItems='center'justifyContent='flex-end'>
                      {/* <Flex flexDirection='column' > */}
                        {/* <Typography variant='body1' sx={{ fontWeight: 500 }}>Visualizar:</Typography>
                        <Flex>
                          <Switch label="B2B" name="storeB2B" control={control} />
                          <Switch label="B2C" name="s toreB2C" control={control} />
                        </Flex>
                      </Flex> */}

                      {/* <Button variant='outlined' LeftIcon={() => <IoFilterOutline size={18} />} sx={{ width: '100px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() =>   setShowFiltersModal(true)}>Filtros</Button> */}
                     
                      <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/price-policies-form')}
                    >Adicionar</Button>
                    </Flex>}
                >
                  {!!data?.length ? <Table data={data} columns={columns} onPageChange={listPolicies} totalCount={totalRegisters} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { PricePoliciesList }